<template>
  <div>
    <BookedFromPlaceCancelModal
      :dialog="cancelPlaceDialog"
      @confirmed="cancelPlaceDialog = false"
    ></BookedFromPlaceCancelModal>
    <v-card :width="$isMobile ? (windowInnerWidth * 0.98) - 80 : 734" v-if='roomList.length' style='background: #f3f4f6; border: none'>
      <v-card-text
        v-for='(item, index) in roomList'
        :key='index'
        class='pa-4 pb-1'
      >
        <div class='d-flex align-start flex-wrap'>
          <v-card
            :class="['mb-4', 'mr-6']"
            :width="$isMobile ? '' : 220"
          >
            <v-card-title class='pb-2 pa-4'>
              <div style='width: 100%' class='d-flex align-center justify-space-between'>
                <div class='d-inline-block text-truncate' style='width: 70%'>
                  <span style='font-size: 18px; color: #000; font-weight: 700'>
                    {{ item.roomName }}
                  </span>
                </div>
                <div v-if="language === 'chinese'" style='font-size: 18px; color: #a100ff; font-weight: 700'>
                  {{ getPlaceApproveStateAliasName(item.state) }}
                </div>
              </div>
              <div class='mt-1 d-inline-block text-truncate' style='margin-left: -3px'>
                <v-icon size='18' color='#606060'>{{ icons.mdiMapMarkerRadiusOutline }}</v-icon>
                <span style='color: #606060; font-size: 14px; font-weight: 400'>
                  {{ item.building }}
            </span>
              </div>
            </v-card-title>
            <v-img
              height='100'
              :src="item.roomImgUrl ? item.roomImgUrl : 'https://myops.accenture.cn/fs_prod/files/MYOPS/20250509/286fe1495c2824f05dad402b6bc58067.png'"
            >
              <div
                v-if='item.capacity > 1'
                class='text-center mt-2 mr-2'
                style='margin-left: auto; width: 65px; height: 24px;border-radius: 12px;background: linear-gradient(180.00deg, #ececec 0%, #ececec 100%);'>
                <v-icon size='18' color='#606060' class='mr-1'>
                  {{ icons.mdiAccountMultipleOutline }}
                </v-icon>
                <span style='font-size: 12px; color: #000'>{{ item.capacity }}</span>
              </div>

              <div v-if="item.standard_services"
                   class='pl-2 image-grid position-absolute' style="bottom: 0">
                <div v-for="(service, index) in splitStandardServices(item.standard_services)"
                     :key="'StandardService-' + index">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        v-if="getStandardServiceByName(service)"
                        class='mb-1 cursor-pointer' width='20'
                        :src="require(`@/assets/images/standard_services/${getStandardServiceByName(service).iconName}`)">
                      </v-img>
                    </template>
                    <span>{{ getStandardServiceByName(service).name }}</span>
                  </v-tooltip>
                </div>
              </div>
            </v-img>
          </v-card>
          <div>
            <div class='mt-0'>
              <div class="prompt" v-if="language === 'chinese'" style='color: #000000'>
                您预订{{ item.cityName
                }}{{ item.cityName === '大连' ? '' : item.buildingName
                }}{{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName
                }}，{{ language === 'chinese' ? '信息如下' : 'The information is as follows' }}：
              </div>
              <div v-else class="prompt" style='color: #000000'>
                You make a reservation {{ item.city
                }} {{ item.cityName === '大连' ? '' : item.building
                }} {{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName
                }}，{{ language === 'chinese' ? '信息如下' : 'The information is as follows' }}：
              </div>
              <div :class="['font-weight-black', language === 'chinese' ? 'mt-4' : 'mt-2', 'place-detail']"
                   style='color: #000000'>
                <div v-if="language === 'english'" class='d-flex align-center'>
                  <div class='circle mr-2'></div>
                  State：{{ item.state }}
                </div>
                <div class='d-flex align-center'>
                  <div class='circle mr-2'></div>
                  {{ language === 'chinese' ? '开始时间' : 'Start' }}：{{ getDateFromDate(item.start)
                  }}({{ calculateWeekday(item.start) }})
                </div>
                <div :class="['d-flex', 'align-center', language === 'chinese' ? 'mt-2' : 'mt-0']">
                  <div class='circle mr-2'></div>
                  {{ language === 'chinese' ? '结束时间' : 'End' }}：{{ getDateFromDate(item.end)
                  }}({{ calculateWeekday(item.end) }})
                </div>
              </div>
              <div
                :class="['d-flex', 'align-center', 'justify-start', language === 'chinese' ? 'mt-6' : 'mt-2', 'mb-1']">
                <v-btn color='primary'
                       :loading='item.loading'
                       :disabled='item.disabled'
                       @click='cancelBooked(item)'
                       small
                >
                  {{ language === 'chinese' ? '取消预订' : 'Cancellation' }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <div v-if='roomList.length > 1 && index !== roomList.length - 1'
             style='width: 100%; height: 1px; background: #e3e1e1'>
        </div>
      </v-card-text>
    </v-card>
    <v-card v-else style='background: #f3f4f6; border: none' class='pa-4' :width="$isMobile ? (windowInnerWidth * 0.98) - 80 : 734">
      <div v-if="language === 'chinese'" :class="['text-center', 'mt-3', 'mb-2']" style='font-size: 14px'>
        <div>抱歉，您目前没有已预订的会议室 / 工位， 若您有任何疑问或需要进一步的协助，</div>
        <div>请联系<a href='mailto:GreaterChina.OfficeSupport@accenture.com'>GreaterChina.OfficeSupport@accenture.com</a>,
          谢谢。
        </div>
      </div>
      <div v-else class='text-center mt-3 mb-2' style='font-size: 14px'>
        <div>Sorry, you currently do not have any reserved conference rooms/open workspace.</div>
        <div>If you have any questions or need further assistance,</div>
        <div>please contact <a href='mailto:GreaterChina.OfficeSupport@accenture.com'>GreaterChina.OfficeSupport@accenture.com</a>,
          Thank you.
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mdiAccountMultipleOutline, mdiMapMarkerRadiusOutline } from '@mdi/js'
import moment from 'moment'
import { cancelPlacesReservableInfo } from '@/modules/chat/api'
import { getChineseWeekday } from '@/modules/chat/util/ChatBotUtil'
import { StandardServicesMix } from '@/modules/chat/view/chatbot/mixin/commonMixin'
import BookedFromPlaceCancelModal from '@/modules/chat/components/BookedFromPlaceCancelModal'

export default {
  components: {
    BookedFromPlaceCancelModal,
  },
  props: {
    roomList: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {
      },
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  mixins: [StandardServicesMix],
  watch: {
    'item.msgId': {
      handler(val) {
        this.roomList.forEach(room => {
          room.disabled = this.item.componentDisabled
        })
      },
      immediate: true,
    },
  },
  computed: {
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data() {
    return {
      icons: {
        mdiMapMarkerRadiusOutline,
        mdiAccountMultipleOutline,
      },
      cancelPlaceDialog: false,
    }
  },
  methods: {
    getPlaceApproveStateAliasName(code) {
      if (code === 'Awaiting approval') {
        return this.language === 'chinese' ? '审批中' : 'In approval'
      } else {
        return this.language === 'chinese' ? '已预订' : 'Reserved'
      }
    },
    getTimeFromDate(dateString) {
      return moment(dateString).format('HH:mm')
    },
    getDateFromDate(dateString) {
      return moment(dateString).format('YYYY-MM-DD HH:mm')
    },
    calculateWeekday(inputDate) {
      if (moment(inputDate, 'YYYY-MM-DD').isValid()) {
        const weekDay = moment(inputDate, 'YYYY-MM-DD').format('dddd')
        return this.language === 'chinese' ? getChineseWeekday(weekDay) : weekDay
      } else {
        return null
      }
    },
    async cancelBooked(item) {
      if (item.dataSources === 'place') {
        this.cancelPlaceDialog = true
      } else {
        this.$set(item, 'loading', true)
        const { data: { code, data, msg } } = await cancelPlacesReservableInfo({
          number: item.number,
          roomName: item.roomName,
          roomId: item.roomId,
        })
        this.$set(item, 'loading', false)
        if (code === 200) {
          this.$set(item, 'disabled', true)
          this.$emit('cancelBookingCompletedEmit', { code, ...data })
        } else {
          this.$emit('cancelBookingCompletedEmit', { code, errorMsg: msg, ...data })
        }
      }
    },
  },
}
</script>
<style scoped>
.circle {
  width: 12px;
  height: 12px;
  background: #a100ff;
  border-radius: 50%; /* 关键属性 */
}

/* 图片纵向排列，超过三个图新起一列 */
.image-grid {
  margin-top: 10px;
  margin-left: -5px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20px, 1fr));
  grid-template-rows: repeat(3, 1fr);
  grid-auto-flow: column;
}

/* 移动端样式 */
@media (max-width: 767px) {
  .prompt {
    font-size: 14px;
  }
  .place-detail {
    font-size: 13px;
  }
}

/* 桌面端样式 */
@media (min-width: 768px) {
  .prompt {
    font-size: 16px;
  }
  .place-detail {
    font-size: 15px;
  }
}
</style>
